<script>
  import { widgetHomeUrl } from "app/utils/urls";
  import { goto } from "$app/navigation";
  import { communitySlug } from "$stores/community";

  goto(widgetHomeUrl({ communitySlug: $communitySlug }));
</script>
